<template>
  <label class="account" :class="{'account--active': isAccountChecked}">
    <div class="row align-items-center py-2">
      <div class="col-12 col-md-6 d-flex align-items-center">
        <div class="account__col relative">
          <input
            type="checkbox"
            class="mr-3 custom-checkbox"
            :checked="isAccountChecked"
            v-on:change="selectAccount(accountData.resourceId)"
          />
          <span class="custom-checkbox__span"></span>
          <h5 class="my-1">{{accountTitle}}</h5>
          <span v-if="balance">{{balanceString}}</span>
        </div>
      </div>
      <div class="col-12 col-md-6 text-md-right">
        <div class="account__col">
          <span
            v-if="accountData.accountId && accountData.accountId.iban"
          >IBAN: {{accountData.accountId.iban}}</span>
          <span
            v-else-if="accountData.accountId && accountData.accountId.other"
          >{{accountData.accountId.other.schemeName}}: {{accountData.accountId.other.identification}}</span>
          <span
            class="d-block"
            v-if="accountExtendedData.transactions"
          >Sample transactions: {{accountExtendedData.transactions.length}}</span>
        </div>
      </div>
    </div>
  </label>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { currencySymbols } from '../../constants'

export default {
  name: 'AccountItem',
  data() {
    return {
      currencySymbols
    }
  },
  props: {
    accountData: {
      type: Object,
      default: () => ({})
    },
    accountExtendedData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters('personal', ['selectedAccounts']),
    isAccountChecked() {
      return this.selectedAccounts.includes(this.accountData.resourceId)
    },
    balance() {
      return this.accountExtendedData.balances && (
        this.accountExtendedData.balances.find(b => b.balanceType === 'ITAV') ||
        this.accountExtendedData.balances.find(b => b.balanceType === 'FWAV') ||
        this.accountExtendedData.balances.find(b => b.balanceType === 'ITBD') ||
        this.accountExtendedData.balances.find(b => b.balanceType === 'VALU') ||
        this.accountExtendedData.balances.find(b => b.balanceType === 'XPCD') ||
        this.accountExtendedData.balances.find(b => b.balanceType === 'CLBD') ||
        this.accountExtendedData.balances[0])
    },
    balanceString() {
      return `${this.balance.balanceAmount.amount && this.balance.balanceAmount.amount.toLocaleString()}
        ${currencySymbols[this.balance.balanceAmount.currency.toLowerCase()] || this.balance.balanceAmount.currency}`
    },
    accountTitle() {
      const titleInfo = []

      if (this.accountData.name) {
        titleInfo.push(this.accountData.name)
      }
      if (this.accountData.details) {
        titleInfo.push(this.accountData.details)
      }
      if (this.accountData.product && this.accountData.product !== this.accountData.details) {
        titleInfo.push(this.accountData.product)
      }
      return titleInfo.join(' / ')
    }
  },
  methods: {
    ...mapActions('personal', ['setAccountSelected']),
    selectAccount() {
      this.setAccountSelected(this.accountData.resourceId)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/variables';

.account {
  display: block;
  background-color: #fff;
  background-color: var(--element-bg);
  padding: 0.5rem 1rem;
  border-radius: $border-radius;
  margin-bottom: $grid-gutter-width;
  cursor: pointer;
  position: relative;
  box-shadow: inset 0 0 0 1px $gray-200;
  box-shadow: inset 0 0 0 1px var(--element-border);
  &:hover {
    background-color: $gray-100;
    background-color: var(--element-bg-dark);
  }
  &:active,
  &--active {
    color: #fff;
    background: linear-gradient(45deg, darken($theme, 5%), $blue);
    box-shadow: none;
    h5 {
      color: #fff;
    }
    &:hover {
      background: linear-gradient(45deg, $theme, $blue);
    }
  }
  &__title {
    display: flex;
  }
  &__col {
    position: relative;
    padding-left: 30px;
    .custom-checkbox__span {
      position: absolute;
      left: 0;
      top: 1px;
    }
  }
}
</style>
